export const environment = {
  production: true,
  name: 'QA',
  api_url: 'https://qa.api.detect-test.questtitan.com',
  version: require('../../package.json').version,
  reCaptchaSiteKey: '6Le60d4UAAAAADk3r4Hae4U0wrVfQF4vB1Jw6CAF',
};
